import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';

interface PluggyTokenPayload {
  client_user_id: string;
  item_id: string;
}

const getPluggyToken = async (payload?: PluggyTokenPayload) => {
  const { data } = await api.post<PluggyTokenResponse>(
    apiConfig.routes.wallet.pluggy.token,
    payload
  );
  return data;
};

// Listagem de corretoras e detalhes da carteira
export const useGetPluggyToken = (payload?: PluggyTokenPayload) => {
  return useQuery({
    queryKey: ['pluggy', 'token', payload],
    queryFn: () => getPluggyToken(payload),
  });
};

type PluggyTokenResponse = { access_token: string };
